import { mobileAccess } from "./skyward.base.global";
import { loadContent } from "./skyward.ui.window";
import { ModalDialog } from "./types";

const skyward = window.skyward;

let idleState = "monitor not enabled";

const MONITORED_ACTIONS = 'keydown click';
let enabled = false;

// warningTimers[] holds all timers that need to be reset on user input.
const warningTimers: NodeJS.Timeout[] = [];
let finalTimeOutTimer: NodeJS.Timeout;
let minutesElapsedTimer: NodeJS.Timeout;
let warningMessage: ModalDialog | null;

let sessionStatePostInterval = 30000;
let warnTime = 600000;
let timeoutTime = 900000;

export function enable(sessionStatePostIntervalParam: number | null, warnTimeParam: number | null, timeoutTimeParam: number | null)
{
    sessionStatePostInterval = sessionStatePostIntervalParam || sessionStatePostInterval;
    warnTime = warnTimeParam || warnTime;
    timeoutTime = timeoutTimeParam || timeoutTime;

    if (!mobileAccess)
    {
        startWarningTimers();
    }

    if (enabled)
    {
        return;
    }

    $(document).on(MONITORED_ACTIONS, markActivity);

    skyward.session.enable(sessionStatePostIntervalParam);
    enabled = true;
}

export function startWarningTimers(offset?: number | null)
{
    stopWarningTimers();

    if (offset == undefined || offset == null || isNaN(offset))
    {
        offset = 0;
    }

    clearTimeout(finalTimeOutTimer);
    finalTimeOutTimer = setTimeout(onSessionFinalTimeOut, timeoutTime - offset);
    if ((warnTime - offset) > 0)
    {
        clearWarning();
        warningTimers.push(setTimeout(showWarning, warnTime - offset));
    }
    else
    {
        showWarning(offset);
    }
    warningTimers.push(setTimeout(timeout, timeoutTime - offset));
}

export function disable()
{
    skyward.session.disable();
    stopWarningTimers();
    $(document).off(MONITORED_ACTIONS, markActivity);
    idleState = "monitor not enabled";
    enabled = false;
}

function clearWarning()
{
    if (warningMessage)
    {
        warningMessage.close();
        warningMessage = null;
    }
}

function markActivity()
{
    idleState = "Active";
    skyward.session.setState(idleState);
}

function onSessionFinalTimeOut()
{
    skyward.session.postState("ClientTimedOut");
}

function stopWarningTimers()
{
    while (warningTimers.length > 0)
    {
        clearTimeout(warningTimers.pop());
    }
}

function adjustWarningMinutes(newNumber: number)
{
    $("#idleTimeMinutes").text(newNumber);
}

function showWarning(offset?: number)
{
    if (!offset)
    {
        offset = 0;
    }

    const minutesElapsed = (offset > warnTime) ? Math.floor(offset / 60000) : Math.floor(warnTime / 60000);
    clearTimeout(minutesElapsedTimer);
    minutesElapsedTimer = setTimeout(function ()
    {
        adjustWarningMinutes(minutesElapsed + 1);
    }, (60000 - (offset % 60000)));

    if (warningMessage)
    {
        if (skyward.session.currentState() == "Active")
        {
            clearWarning();
        }
        return;
    }

    const originalActiveElement = $(document.activeElement!);

    warningMessage = skyward.modalLayer.showDialog(
        "Session Timeout Warning",
        "<p>Your session has been inactive for over <span id='idleTimeMinutes'>" +
        minutesElapsed +
        "</span> minutes.</p><br/>For security purposes, inactive sessions are automatically signed out after " +
        Math.ceil(timeoutTime / 60000) +
        " minutes.<br/>",
        [{
            text: "Stay Signed In",
            icon: "SignIn",
            click: function ()
            {
                warningMessage!.close();
                originalActiveElement.trigger("focus");
                skyward.session.postState("Active");
            },
            focus: true
        },
        {
            text: "Sign Out",
            icon: "SignOut",
            click: function ()
            {
                warningMessage!.close();
                loadContent('full', 'security', 'SignIn', 'index', null, undefined);
            }
        }],
        {
            forceClose: true,
            additionalClasses: "critical",
            role: "alertdialog"
        }
    );
}

function timeout()
{
    skyward.session.postState("ClientTimedOut");
    stopWarningTimers();
    clearWarning();
}